import { useEffect, useState, useRef } from 'react';
import tw from 'twin.macro';

import { IOrganization } from '@account_module/types/Organizations';
import useOnClickOutside from '@app/hooks/useOnClickOutside';
import { CaretIcon } from '@icons/CaretIcon';

const Container = tw.div`relative w-[calc(100% - 30px)]`;
const SelectedOrganizationTitle = tw.span`flex items-center justify-start gap-[8px] cursor-pointer text-nowrap text-text-and-icon text-[16px] text-nowrap font-semibold leading-normal max-w-full truncate`;
const OptionsContainer = tw.div`absolute bg-page-background shadow-dropdown`;
const Option = tw.button`w-full p-[4px] rounded-[4px] hover:bg-gray-3 text-left`;

export const OrganizationPicker = ({ organizations }: { organizations: IOrganization[] }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const optionsContainerRef = useRef(null);
  useOnClickOutside(optionsContainerRef, () => setIsOpen(false));

  const [selectedOrganization, setSelectedOrganization] = useState<IOrganization | null>(
    organizations?.[0] || null
  );

  const handleSelectOrganization = (organization: IOrganization) => {
    setSelectedOrganization(organization);
    setIsOpen(false);
  };

  useEffect(() => {
    if (organizations?.length) {
      setSelectedOrganization(organizations?.[0]);
    }
  }, [organizations]);

  if (!organizations?.length) return null;

  return (
    <Container>
      <SelectedOrganizationTitle onClick={() => setIsOpen(!isOpen)}>
        <span tw='truncate'>{selectedOrganization?.name}</span>
        <CaretIcon tw='fill-text-and-icon-muted' />
      </SelectedOrganizationTitle>
      {isOpen && (
        <OptionsContainer ref={optionsContainerRef}>
          {organizations.map((organization) => (
            <Option key={organization.id} onClick={() => handleSelectOrganization(organization)}>
              {organization.name}
            </Option>
          ))}
        </OptionsContainer>
      )}
    </Container>
  );
};
